'use client';

import { Container, Pill } from '@mv/web-ui';
import NextLink from 'next/link';
import { useI18n } from '@/modules/i18n/useI18n';
import { useDataTags } from '@/modules/tracking/analytics/useDataTags';
import { formatSlug } from '@/payload/fields/slug/formatSlug';
import type { NavigationBlock as Props } from '@/payload/types';
import styles from './Navigation.module.scss';

function Navigation({ blockType, id, items }: Props) {
	const { blockRef, labelRef } = useDataTags(blockType, id);
	const { terms } = useI18n();

	if (!terms.pageTopics && (!items || items.length === 0)) {
		return null;
	}

	return (
		<Container ref={blockRef}>
			<div className={styles.container} data-component="NavigationBlock">
				{terms.pageTopics && (
					<div ref={labelRef} className={styles.topics}>
						{terms.pageTopics}
					</div>
				)}
				{items && items.length > 0 && (
					<nav aria-label={terms.pageTopics ?? undefined} className={styles.pills}>
						<ul className={styles.list}>
							{items.map((item) => (
								<li key={item.targetBlock} className={styles.listItem}>
									<Pill shadow asChild>
										<NextLink href={`#${formatSlug(item.label)}`}>{item.label}</NextLink>
									</Pill>
								</li>
							))}
						</ul>
					</nav>
				)}
			</div>
		</Container>
	);
}

export default Navigation;
